import AbstractView from "abstracts/AbstractView";
import Device from 'controllers/Device';


export default class EmailCopy extends AbstractView {
	constructor( $wrapper, useText ) {
		super();
		
		this.$wrapper = $wrapper;
		this.$email   = this.$wrapper
		
		this.useText = useText
		
		this.init();
	}
	
	
	initDOM() {
		if ( this.useText ) {
			this.$copyWrapper    = this.$wrapper.find( '.email-copy_copy_wrapper' )
			this.$copyText       = this.$wrapper.find( '.email-copy_copy--text_copy' )
			this.$copiedText     = this.$wrapper.find( '.email-copy_copy--text_copied' )
			this.$copySvg        = this.$copyWrapper.find( 'svg' )
			this.transitionDelay = getComputedStyle( document.documentElement ).getPropertyValue( '--transition-delay' )
		}
		
	}
	
	
	initEl() {
		if ( this.useText ) {
			this._initAnimation();
		}
	}
	
	
	bindEvents() {
		this.eh.clickEmail = this._clickEmail.bind( this );
		this.$email.on( 'click', this.eh.clickEmail );
		
		this.eh.clickCopy = this._copyToClipboard.bind( this );
		this.$email.on( 'click', this.eh.clickCopy );
		
		this.eh.unHoverEmail = this._unHoverEmail.bind( this );
		this.$email.on( 'mouseleave', this.eh.unHoverEmail );
	}
	
	
	unbindEvents() {
		this.$email.off( 'click', this.eh.clickEmail );
		this.$email.off( 'click', this.eh.clickCopy );
		this.$email.off( 'mouseleave', this.eh.unHoverEmail );
	}
	
	
	_clickEmail() {
		const delayAnim = 2.4
		
		if ( this.useText ) {
			document.documentElement.style.setProperty( '--transition-delay', '0s' );
		}
		
		if ( !Device.IS_TOUCH ) {
			if ( !this.tw.delayed || !this.tw.delayed.isActive() ) {
				this.$wrapper.addClass( 'copied' );
				if ( this.useText ) {
					this.tl.copyText.play();
				}
				this._delayedCall( delayAnim );
			}
		}
		
	}
	
	
	_copyToClipboard( e ) {
		if ( !Device.IS_TOUCH ) {
			e.preventDefault();
			if ( e.currentTarget && e.currentTarget.hasAttribute( 'data-text' ) ) {
				navigator.clipboard.writeText( e.currentTarget.getAttribute( 'data-text' ).trim() );
			}
		}
	}
	
	
	_initAnimation() {
		this.tl.copyText = gsap.timeline( { paused: true } )
			.to(
				this.$copyText,
				{
					y:        "-50%",
					opacity:  0,
					duration: 0.2,
					ease:     "power1.out"
				}
			)
			.to(
				this.$copiedText,
				{
					y:        0,
					opacity:  1,
					color:    "white",
					duration: 0.2,
					ease:     "power1.out"
				},
				'<'
			)
		
	}
	
	
	_unHoverEmail() {
		if ( this.useText ) {
			document.documentElement.style.setProperty( '--transition-delay', this.transitionDelay );
		}
		
		this._delayedCall( 0.2 );
	}
	
	
	_delayedCall( delay ) {
		this.tw.delayed = gsap.delayedCall( delay, () => {
			this.$wrapper.removeClass( 'copied' );
			
			if ( this.useText ) {
				setTimeout( () => {
					this.tl.copyText.reverse();
				}, 100 )
			}
			
			this.tw.delayed.kill();
		} )
	}
	
	
}
